import { render, staticRenderFns } from "./publico.vue?vue&type=template&id=182fc0dd&scoped=true"
import script from "./publico.vue?vue&type=script&lang=js"
export * from "./publico.vue?vue&type=script&lang=js"
import style0 from "./publico.vue?vue&type=style&index=0&id=182fc0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182fc0dd",
  null
  
)

export default component.exports